import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiListItemText = {
  styleOverrides: { root: { margin: 0 } },
} satisfies Components<Theme>['MuiListItemText'];
